<script setup>
import "form-wizard-vue3/dist/form-wizard-vue3.css";
import Wizard from "form-wizard-vue3";
import { ref } from 'vue'

const currentTabIndex = ref({ind: 0})
function onChangeCurrentTab(index, oldIndex) {
  currentTabIndex.value.ind = index;
}
function onTabBeforeChange() {
  if (currentTabIndex.value === 0) {
  }
}
function wizardCompleted() {
}

const export_data = ref({
  type: null
})
const export_type = ['Children', 'Intervention', 'Report']
</script>

<template>
  <Breadcrumbs main="Export Child"/>
  <div class="container-fluid text-start">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header pb-0">
            <h3>Simple Form Wizard</h3>
            <span>Please Make sure fill all the filed before click on next button</span>
          </div>
          <div class="card-body">
            <Wizard :custom-tabs="[
            {
              title: 'General Option',
            },
            {
              title: 'Information',
            },
            {
              title: 'Summary',
            },
            ]" :beforeChange="onTabBeforeChange" @change="onChangeCurrentTab" @complete:wizard="wizardCompleted"
            @submit.prevent="onSubmit">
              <div class="col-xs-12" v-if="currentTabIndex.ind == 0">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">Export Type</label>
                    <multiselect 
                      v-model="export_data.type" 
                      placeholder="Select Type"
                      track-by="code" :options="export_type"
                      searchable="true"
                    ></multiselect>
                  </div>
                  <div class="form-group mt-3">
                    <p class="mb-0 fw-medium">Add Filter Option</p>
                    <div class="row">
                      <div class="col-md-4">
                        <label for="element" class="control-label">Element</label>
                        <input class="form-control" type="text" placeholder="Full name"/>
                      </div>
                      <div class="col-md-3">
                        <label for="element" class="control-label">Rule</label>
                        <input class="form-control" type="text" placeholder="NOT EQUAL"/>
                      </div>
                      <div class="col-md-5">
                        <label for="element" class="control-label">Value</label>
                        <input class="form-control" type="text" placeholder="value"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 text-start" v-if="currentTabIndex.ind === 1">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">Rule</label>
                    <input class="form-control" type="text" placeholder="EQUAL"
                    required="required" />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Value</label>
                    <input class="form-control" type="text" placeholder="Value" required="required" />
                  </div>
                </div>
              </div>
              <div class="col-xs-12 text-start" v-if="currentTabIndex.ind === 2">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">Birth date</label>
                    <input class="form-control" type="date" required="required" />
                  </div>
                  <div class="form-group">
                    <label class="control-label">Have Passport</label>
                    <input class="form-control" type="text" placeholder="yes/No" required="required" />
                  </div>
                </div>
              </div>
            </Wizard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>